<script>
import { mapState, mapActions } from 'vuex';
//import MarkerClusterer from '@google/markerclusterer'
import { MARKER_ICONS } from '@/constants/gmaps.js';
import naja from 'naja';

export default {
  props: {
    map: {
      type: Object,
      required: true
    }
    /*google: {
      type: Object,
      required: true
    },
    map: {
      type: Object,
      required: true
    },
    markerProps: {
      type: Object,
      required: true
    }*/
  },

  created() {
    const { Marker, Size, Point } = this.gmaps.google.maps;
    const map = this.map;

    // --- Comment threads ---
    this.$store.dispatch('threads/fetchGlobalThreads').then(() => {
      let allMarkers = this.threads.threadList;
      let markersArray = [];
      for (const key in allMarkers) {
        let single = allMarkers[key];
        let iconType = single.status;
        let iconFin = {
          url: MARKER_ICONS[iconType],
          size: new Size(27, 43),
          origin: new Point(0, 0),
          anchor: new Point(14, 43),
          labelOrigin: new Point(14, 17)
        };
        const marker = new Marker({
          position: {
            lat: parseFloat(single.lat),
            lng: parseFloat(single.lng)
          },
          icon: iconFin,
          label: '' + single.id,
          map: map,
          threadId: single.id
        });
        marker.addListener(`click`, () => this.markerClickHandler(marker));

        markersArray.push(marker);
      }

      // Store marker objects, then enable clusters
      this.$store.dispatch('threads/addGmMarkers', markersArray).then(() => {
        this.$store.dispatch('threads/newCluster', [
          this.map,
          this.threads.markers
        ]);
      });
    });
  },

  computed: {
    ...mapState(['gmaps', 'threads']),
    ...mapActions([
      'threads/addGmMarkers',
      'threads/fetchGlobalThreads',
      'threads/fetchAllAttachedMarkers',
      'general/setLayoutOption',
      'general/setOpenedThreadDetailId'
    ])
  },

  methods: {
    markerClickHandler(marker) {
      window.$wzBus.$emit('event', {
        event: 'click',
        target: {
          type: 'thread-pin',
          id: marker.threadId
        }
      });

      this.$store.dispatch('general/setLayoutOption', ['threadDetail', true]);
      this.$store.dispatch('general/setOpenedThreadDetailId', marker.threadId);

      naja.makeRequest('GET', '?do=getComments&threadId=' + marker.threadId);
    }
  },

  render() {
    return null;
  }
};
</script>
